<template>
  <v-row class="pr-1 sms-detail-setting">
    <v-col cols="12" md="7" class="left-area pa-1">
      <v-card-text>
        <div class="mt-3">
          <div class="title d-flex justify-space-between mb-2 ">
            <span class="subtitle-1 font-weight-bold">메세지 내용</span>
            <div v-if="!is_manual">
              <v-btn small outlined color="grey lighten-3" class="grey lighten-3 text--darken-3 mr-2" @click="initContentText"
                >기본 메시지 적용</v-btn
              >
              <v-menu offset-y transition="slide-y-transition">
                <template v-slot:activator="{ on }">
                  <v-btn small outlined color="grey lighten-3" class="grey lighten-3 text--darken-3" v-on="on">#변수 추가</v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in add_text_list" :key="index" link>
                    <v-list-item-title @click="addContentValue(item.text)">{{ item.desc }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
          <v-textarea v-model="msg_content" outlined hide-details="false" height="200px" class="msg_content"></v-textarea>
          <div class="d-flex justify-end text-xs mt-2">
            [ <span class="blue--text"> {{ msg_content.length }}</span> / 1,000 ]
          </div>
        </div>
      </v-card-text>
      <div>
        <v-card-text class="py-0 ">
          <div class="subtitle-1 font-weight-bold">SMS 발송 설정</div>
          <v-card-subtitle class="black--text pl-0 pb-0">발신번호 선택</v-card-subtitle>
          <v-select v-model="sender_number" :items="sender_number_list" outlined dense hide-details="false" placeholder="선택"></v-select>
          <v-card-subtitle class="black--text pl-0 pb-0">수신 거부자 발송 여부</v-card-subtitle>
          <v-select v-model="send_reject_type" :items="send_reject_items" outlined dense hide-details="false"></v-select>

          <v-card-subtitle class="black--text pl-0 pb-0">90byte 초과시 단문/장문 발송 선택</v-card-subtitle>
          <v-select v-model="send_sms_type" :items="send_sms_items" outlined dense hide-details="false"></v-select>
        </v-card-text>
      </div>
    </v-col>

    <v-col cols="12" md="5" class="right-area pl-0">
      <v-card class="preview px-2" outlined>
        <v-card-subtitle class="font-weight-bold black--text">미리보기</v-card-subtitle>
        <v-card-text class="preview_area">
          <div class="preview_content">
            <div>
              <v-card-text v-html="changePreviewContent(msg_content)"></v-card-text>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <div class="mt-2 text-xs">
        <ul class="grey--text ">
          <li>
            카페24 SMS을 연동하여 사용합니다.
          </li>
          <li>
            연동 발송시 카페24 SMS 충전에서 차감되어요.
          </li>
          <li>
            <a :href="moveAdminPage()" target="_blank" class="decoration-none">
              [ 관리자 > 쇼핑몰 설정 > 메시지 설정 > 메시지 사용 설정 ] </a
            >메뉴에 SMS 사용설정이 ‘사용함’으로 설정되어 있어야 연동이 가능합니다.
          </li>
        </ul>
      </div>
    </v-col>
    <v-col cols="12" class="d-flex justify-space-between pa-4 pb-0 mt-10">
      <v-btn width="49%" dark @click="closeModal">닫기</v-btn>
      <v-btn width="49%" class="info" @click="saveSettings">저장</v-btn>
    </v-col>
  </v-row>
</template>

<style>
.sms-detail-setting .msg_content {
  font-size: 1em;
}

.sms-detail-setting .msg_content textarea {
  margin-top: 0px !important;
  padding-top: 10px;
}

.sms-detail-setting .preview_content {
  margin-top: 16px;
  border: 1px solid #dadada;
  border-radius: 10px;
  background: #fff;
}

.sms-detail-setting .preview_area {
  width: auto !important;
  border: 2px solid #dadada;
  padding: 10px;
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
  margin-left: 12px;
  margin-right: 12px;
  background: #bfd1db;
}

.sms-detail-setting .decoration-none {
  text-decoration: none;
}
</style>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
export default {
  data() {
    return {
      msg_content: "",
      send_reject_type: "NO",
      send_sms_type: "sms",
      sender_number: null,
      sender_number_list: [],
      send_reject_items: [
        { text: "발송함", value: "NO" },
        { text: "발송 안 함", value: "YES" },
      ],
      send_sms_items: [
        { text: "SMS 단문 (90byte 초과시 여러개 발송)", value: "sms" },
        { text: "LMS 장문 (2000byte 초과시 한번에 발송)", value: "lms" },
      ],
      add_text_list: null,
      sample_content_data: this.getSampleData(),
    };
  },
  mixins: [CommonMixin],
  props: {
    msg_type: {
      type: String,
      required: true,
    },
    msg_title: {
      type: String,
      required: true,
    },
    is_manual: {
      type: Boolean,
      default: false,
    },
  },
  created: async function() {
    //console.log(" sms detail area create check", this.msg_type);
    await this.getSenderNumber();
    this.resetSmsDetailSetting();
  },
  watch: {
    msg_type: function() {
      this.resetSmsDetailSetting();
    },
  },
  methods: {
    resetSmsDetailSetting() {
      this.msg_content = this.getInitContentText(this.msg_type);
      this.send_reject_type = "NO";
      this.send_sms_type = "sms";
      this.sender_number = null;
      this.add_text_list = this.getUserTagList(this.getIsOrderMessage(this.msg_type), this.getAbleSerialTag(this.msg_type));
      this.getSmsDetailSetting();
      if (["buyed_confirm", "shipping_end"].includes(this.msg_type)) {
        this.getCheckTag(this.msg_type);
        this.applyQrUrlFilter(this.msg_type);
      }
    },
    // 2026-07-25: 자동 생성 설정과 매칭되지 않는 msg_type 에서는 REGISTRATION_QR_URL 태그 제거.
    applyQrUrlFilter: async function(chk_type) {
      const qr_tag = "#{REGISTRATION_QR_URL}";
      const autoGenerateEvent = await this.getAutoGenerateEvent(M);
      if (!this.isQrUrlAllowedForMsgType(chk_type, autoGenerateEvent)) {
        this.add_text_list = this.add_text_list.filter((tag) => tag.text !== qr_tag);
        return;
      }
      const used = await this.getUseTypeByTag(M, qr_tag, chk_type);
      if (used) {
        this.add_text_list = this.add_text_list.filter((tag) => tag.text !== qr_tag);
      }
    },
    getSetData: function() {
      const data = {
        msg_type: this.msg_type,
        sms_content: this.msg_content,
        exclude_unsubscriber: this.send_reject_type === "YES" ? "enabled" : "disabled",
        sms_type: this.send_sms_type,
        sms_title: this.msg_title,
        sender_no: this.sender_number,
        sender_hp: this.sender_number_list.find((item) => item.value === this.sender_number).text,
      };
      return data;
    },
    getSmsDetailSetting: async function() {
      try {
        // call API
        const res = await M.api(M.entry("/get/message/detail/sms"), { msg_type: this.msg_type });
        if (res) {
          if (res.sms_content.length > 0) {
            this.msg_content = res.sms_content;
          }
          this.send_sms_type = res.sms_type.toLowerCase();
          this.sender_number = this.sender_number_list.find((item) => item.text === res.sender_hp).value;
          this.send_reject_type = res.exclude_unsubscriber === "enabled" ? "YES" : "NO";
        }
      } catch (err) {
        console.log("get Sms Detail Setting", err);
      }
    },
    getSenderNumber: async function() {
      // call API sender
      try {
        const res = await M.api(M.entry("/get/message/config/sender_list"));
        if (res) {
          this.sender_number_list = res.map((item) => ({
            value: item.sender_no,
            text: item.sender,
          }));
        }
      } catch (err) {
        console.log("get sender number", err);
      }
    },
    moveAdminPage() {
      return "https://" + this.$store.state.mallId + ".cafe24.com/disp/admin/shop" + this.$store.state.shopNo + "/sms/settingsms";
    },
    closeModal() {
      this.$emit("close");
    },
    validateInput() {
      if (this.msg_content.trim() === "") {
        this.alertShow("메세지 내용을 입력해주세요.");
        return false;
      }
      if (this.sender_number === null && this.sender_number_list.length > 0) {
        this.alertShow("발신번호를 선택해주세요.");
        return;
      }
      return true;
    },
    saveSettings() {
      if (!this.validateInput()) {
        return;
      }
      const data = this.getSetData();
      this.setSmsDetailSetting(data);
    },
    setSmsDetailSetting: async function(data) {
      try {
        const check_tag = "#{SERIAL_CODE}";
        if (this.isTagUsed(data.sms_content, check_tag)) {
          // console.log("SERIAL_CODE TAG used");
          if (await this.getUseTypeByTag(M, check_tag, this.msg_type)) {
            alert(
              "시리얼코드(미인증 코드 발송) 변수는 \n중복코드 발송 방지를 위해 배송완료 또는 구매확정 상태 발송시 1번만 발송이 가능합니다.\n해당 변수가 이미 추가된 상태이므로 삭제 후 설정해주세요.",
            );
            this.msg_content = this.msg_content.replace(check_tag, "");
            return;
          }
        }
        const qr_tag = "#{REGISTRATION_QR_URL}";
        if (this.isTagUsed(data.sms_content, qr_tag)) {
          const autoGenerateEvent = await this.getAutoGenerateEvent(M);
          if (!this.isQrUrlAllowedForMsgType(this.msg_type, autoGenerateEvent)) {
            const allowedLabel = autoGenerateEvent === "shipping_done" ? "배송완료" : autoGenerateEvent === "purchase_confirmed" ? "구매확정" : "";
            alert(
              "쇼핑몰 정품 QR 링크 변수는\n자동 생성 설정과 일치하는 상태 발송에만 사용할 수 있습니다." +
                (allowedLabel ? `\n\n현재 자동 생성 설정: ${allowedLabel} → ${allowedLabel} 상태 발송에서만 사용 가능합니다.` : "") +
                "\n해당 변수가 이미 추가된 상태이므로 삭제 후 설정해주세요.",
            );
            this.msg_content = this.msg_content.replace(qr_tag, "");
            return;
          }
          if (await this.getUseTypeByTag(M, qr_tag, this.msg_type)) {
            alert(
              "쇼핑몰 정품 QR 링크 변수는\n중복 방지를 위해 배송완료 또는 구매확정 상태 발송 중 1번만 사용할 수 있습니다.\n해당 변수가 이미 추가된 상태이므로 삭제 후 설정해주세요.",
            );
            this.msg_content = this.msg_content.replace(qr_tag, "");
            return;
          }
        }
        // call API
        const res = await M.api(M.entry("/put/message/detail/sms"), data);
        if (res) {
          this.alertShow("저장되었습니다.");
        }
      } catch (err) {
        console.log("set Sms Detail Setting", err);
      }
    },
    getCheckTag: async function(chk_type) {
      const check_tag = "#{SERIAL_CODE}";
      try {
        const chk = await this.getUseTypeByTag(M, check_tag, chk_type);
        if (chk) {
          this.add_text_list = this.add_text_list.filter((tag) => tag.text !== check_tag);
        }
      } catch (err) {
        console.log("get check tag", err);
      }
    },
    addContentValue: function(text) {
      this.msg_content += text;
    },
    changePreviewContent: function(content) {
      let result = content;
      for (let key in this.sample_content_data) {
        result = result.replace(new RegExp(key, "g"), this.sample_content_data[key]);
      }
      return result.replace(/\n/g, "<br>");
    },
    initContentText() {
      if (confirm("기본 제공하는 메시지 문구로 변경되어요.\n진행하시겠습니까?")) {
        this.msg_content = this.getInitContentText(this.msg_type);
      }
    },
  },
};
</script>
